import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadTagCategories, TagsActions, TagsSelector } from "shared/reducers/Tags";

const TagCategoriesProvider = ({ children }: { children: React.ReactNode }) => {
    const categoriesLoaded = useSelector(TagsSelector)?.tagCategoriesLoaded;
    const dispatch = useDispatch();
    useEffect(() => {
        if (!categoriesLoaded) {
            dispatch(loadTagCategories({}))
            dispatch(TagsActions.setTagCategoriesLoaded(true))
        }
    }, [categoriesLoaded, dispatch]);
    
    return <>{children}</>
}

export default TagCategoriesProvider;import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadTagCategories, TagsActions, TagsSelector } from "shared/reducers/Tags";

const TagCategoriesProvider = ({ children }: { children: React.ReactNode }) => {
    const categoriesLoaded = useSelector(TagsSelector)?.tagCategoriesLoaded;
    const dispatch = useDispatch();
    useEffect(() => {
        if (!categoriesLoaded) {
            dispatch(loadTagCategories({}))
            dispatch(TagsActions.setTagCategoriesLoaded(true))
        }
    }, [categoriesLoaded, dispatch]);
    
    return <>{children}</>
}

export default TagCategoriesProvider;